import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './FiltroRapido.module.sass'


interface Props {
  id: string
  name?: string
  value?: string
  label?: string
  number?: number
  color?: 'blue' | 'blue-green' | 'danger' | 'yellow' | 'info' | 'violet'
  selected?: boolean
  onChange?: (v: boolean) => void
  className?: string
}

const FiltroRapido = (props: Props) => {

  const { 
    id,
    name,
    value = '1',
    label,
    number,
    color = 'blue',
    selected = false,
    onChange,
    className = '',
  } = props

  return (
    <label htmlFor={id} className={cn(styles.root, styles[`root--${color}`], selected ? styles['root--selected'] : '', className)}>
      <input
        id={id}
        name={name}
        checked={selected}
        value={value}
        className={styles.input}
        type="checkbox"
        onChange={(e) => onChange(e.target.checked)}
      />
      <div className={styles.styledInput}>
        <span className={styles.dot} />
        <span className={styles.label}>{label}</span>
        {typeof number !== 'undefined' && <span className={styles.number}>{number}</span>}
      </div>
    </label>
  )
}

export default FiltroRapido
